/*                                                      */
/*                        WARNING                       */
/*                                                      */
/*   This file was auto-generated by the localization   */
/*   parser and it should never be manually modified.   */
/*                                                      */

import de from './de/web-pages-launcher-ui.json'
import en from './en/web-pages-launcher-ui.json'
import zh from './zh/web-pages-launcher-ui.json'
import { SupportedLocale } from './index'

export type LocalizationContent = typeof en
export type LocalizationKey = keyof LocalizationContent

export const locales: Record<SupportedLocale, LocalizationContent> = {
  de,
  en,
  zh,
}
